module.exports = __webpack_public_path__ + "static/media/Gallary2.8bfe1a24.webp";